import React from 'react'
import { Route, Switch } from 'react-router-dom'

import RoleGuard from '../../components/RoleGuard'
import { USER_EXPORT_ROLES } from '../../constants/roles'
import UserExportsList from './UserExportsList'

export default () => {
    return {
        routes: [
            {
                path: '/user-export',
                render: ({ match }) => (
                    <RoleGuard roles={USER_EXPORT_ROLES}>
                        <Switch>
                            <Route path={`${match.url}`} exact component={UserExportsList} />
                        </Switch>
                    </RoleGuard>
                ),
            },
        ],
    }
}